export const SORT_KEYS = ['alphabetical', 'aum', 'experience', 'clients'] as const;

export type Sort = (typeof SORT_KEYS)[number];

export const DEFAULT_SORT: Sort = 'alphabetical';

export const SORT_LABELS: Record<Sort, string> = {
  alphabetical: 'Alphabetical',
  aum: 'AUM',
  experience: 'Years of experience',
  clients: '# of clients',
};
